/**
 * Created by codeOasis on 27/08/23.
 */

import '../../styles/client/carrouselStyle.scss';

import './carrouselScript.js';



// WEBPACK FOOTER //
// ./assets/scripts/client/init.ts